export { default } from './ConsentAlert';
